import { ReactNode } from 'react';
import { ApolloAuthClient } from '@brainpool/apollo-connect';

import { loggerService } from '@brainpool/logger';
import { context } from './apollo/context';
import { createTuneddCache } from './apollo/cacheConfig';

export interface TuneddProviderProps {
  children: ReactNode;
  clerkKey: string;
  restApiUrl: string;
  graphQLUrl: string;
  companionEndpoint: string;
  websocketUrl: string;
  productFruitsNewCaseSurveyId: string;
  googleDriveClientId: string;
  googleDriveApiKey: string;
  googleDriveAppId: string;
}

export function TuneddProvider({
  children,
  clerkKey,
  restApiUrl,
  graphQLUrl,
  companionEndpoint,
  websocketUrl,
  productFruitsNewCaseSurveyId,
  googleDriveClientId,
  googleDriveApiKey,
  googleDriveAppId,
}: TuneddProviderProps) {
  if (!clerkKey || !restApiUrl || !graphQLUrl) {
    loggerService.log({
      message: `TuneddProvider: Missing required props. clerkKey: ${!!clerkKey}, restApiUrl:${!!restApiUrl},  graphQLUrl:${!!graphQLUrl}.`,
      logLevel: 'error',
      context: {
        action: 'TuneddProvider',
      },
    });
    return null;
  }

  context.restApiUrl = restApiUrl;
  context.companionEndpoint = companionEndpoint;
  context.websocketUrl = websocketUrl;
  context.productFruitsNewCaseSurveyId = productFruitsNewCaseSurveyId;
  context.googleDriveClientId = googleDriveClientId;
  context.googleDriveApiKey = googleDriveApiKey;
  context.googleDriveAppId = googleDriveAppId;

  const tuneddCache = createTuneddCache();

  return (
    <ApolloAuthClient context={context} clerkKey={clerkKey} apiUrl={graphQLUrl} cache={tuneddCache}>
      {children}
    </ApolloAuthClient>
  );
}

export default TuneddProvider;
